import { useCallback, useLayoutEffect, useRef } from 'react';

export const useEvent = <T extends (...arg: any[]) => any>(fn: T) => {
  const fnRef = useRef(fn);

  useLayoutEffect(() => {
    fnRef.current = fn;
  }, [fn]);

  return useCallback(
    (...arg: Parameters<T>) => {
      return fnRef.current.apply(null, arg);
    },
    [fnRef],
  );
};
